export function storeOneRecipeAction(recipe){
    // console.log('STORE_ONE_RECIPE Action is ', recipe)
    return {
        type: "STORE_ONE_RECIPE",
        currentRecipe: recipe
    }
}
